import React from 'react';
import $ from 'jquery';
import ImageSvg from '../images/ImageSvg.react';
import FlashMessageStore from '../../stores/FlashMessageStore.js';
import get from 'lodash/get';
import responsiveness from '../../../../../../sass/foundation/variables/responsiveness.scss';

/* var Dropzone = require('react-dropzone'); */
const maxUploadFileSizeMb = get(globals, 'maxUploadFileSizeMb', 5);

class ImageUpload extends React.Component {
	static defaultProps = {
		hide: false,
	};

	state = {
		loading: false,
	};

	handleClick = (e) => {
		if (this.state.loading
			|| (this.props.verifySubmitAllowed && !this.props.verifySubmitAllowed())
		) {
			e.preventDefault();
		}
	}

	handleChange = (e) => {
		if (!e.target.value) {
			return;
		}
		this.setState({
			loading: true
		});
		var data = new FormData();
		// slēptā galerija
		data.append('hidden_gallery', true);

		const options = { style: { top: 0 } };
		const $messageComposer = $('.messageComposer');
		if ($messageComposer.length) {
			options.style.top = $messageComposer.position().top;

			if ($(window).width() > responsiveness.breakpoint) {
				options.style.width = $messageComposer.outerWidth();
				options.style.left = 'auto';
			}
		}

		var stopUpload = false;
		$.each($('#upload_files')[0].files, function(i, file) {
			var sizeInBytes = get(file, 'size', false);

			if (!sizeInBytes || sizeInBytes / (1024*1024) > maxUploadFileSizeMb) {
				var errorText = !sizeInBytes ? 'txt: Nevarējām iegūt datus par bildes faila izmēru' : 'txt: Bilde par lielu. Maksimālais pieļaujamais bildes faila izmērs {:size} megabaiti.';
				var errorMessage = get(translations, errorText, errorText);

				if (errorMessage.includes('{:size}')) {
					errorMessage = errorMessage.replace('{:size}', maxUploadFileSizeMb);
				}

				FlashMessageStore.removeAll();
				FlashMessageStore.add(`${String(Date.now())}_${file.name}`, 'error', `${errorMessage} (${file.name})`, options);
				FlashMessageStore.emitChange();

				stopUpload = true;
				return;
			}

			data.append('files[]', file);
		});

		var _this = this;
		if (stopUpload) {
			_this.setState({
				loading: false
			});
			return;
		}

		$.ajax({
			url: '/images/upload_multiple.json',
			data: data,
			cache: false,
			contentType: false,
			processData: false,
			type: 'POST',
			complete: function(data) {
				_this.setState({
					loading: false
				});
			},
			success: function(data){
				var fileName = $('#upload_files')[0].value;
				const uncensoredFilenames = data.uncensored_filenames || [];
				if (typeof data.status == 'undefined' || data.status == 'error') {
					// In case if uploaded multiple and some were added successfully
					if (typeof data.filenames !== 'undefined' && data.filenames.length) {
						for (var i = 0; i < data.filenames.length; i++) {
							_this.props.addImage(data.filenames[i], uncensoredFilenames.includes(data.filenames[i]));
						}
					}
					var message = get(translations, 'txt: Kļūda! Nevar ielādēt saturu.', 'txt: Kļūda! Nevar ielādēt saturu.');
					if (typeof data.message !== 'undefined') {
						message = data.message;
					}
					FlashMessageStore.removeAll();
					FlashMessageStore.emitChange();
					FlashMessageStore.add(fileName, 'error', message, options);
					FlashMessageStore.emitChange();
				}
				else if (data.status == 'ok') {
					if (typeof data.filenames !== 'undefined') {
						for (var i = 0; i < data.filenames.length; i++) {
							_this.props.addImage(data.filenames[i], uncensoredFilenames.includes(data.filenames[i]));
						}
					}
					else if (typeof data.id !== 'undefined') {
						_this.props.addImage(data.id, uncensoredFilenames.includes(data.id));
					}
				}
			},
			error: function(data) {
				// console.log(data);
			}
		});
	};

	render() {
		return (
			<div className={`di${this.props.hide ? ' hide' : ''}`}>
				<label
					htmlFor="upload_files"
					className={`btn btn--b btn--small btn--iconLeft imageUpload${this.state.loading ? ' has-loader' : ''}`}
				>
					<span className="btn-static">
						<ImageSvg svg="icon-photos" iconClass="icon--center icon--photos" />
					</span>
					<span className="btn-text">{get(translations, 'txt: Sūtīt foto', '')}</span>
				</label>
				<input
					onChange={this.handleChange}
					onClick={this.handleClick}
					name="files[]"
					type="file"
					multiple="multiple"
					id="upload_files"
					accept="image/jpeg,image/jpg,image/png"
					hidden
				/>
			</div>
		);
	}
}

module.exports = ImageUpload;
